import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className = '',
  id,
  delay = 0
}: SectionProps) {
  return <section id={id} className={`py-16 md:py-24 ${className}`} data-id="element-134">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      delay,
      ease: 'easeOut'
    }} className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-135">
        {children}
      </motion.div>
    </section>;
}